import styled from 'styled-components';

export const VStack = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1280px;
  justify-content: space-between;
  align-items: stretch;
  margin: auto;
`;
